module.exports = function getResource(label) {
    const resources = {
        removePhoto: 'Retirer la photo',
        addPhoto: 'Ajouter une photo',
        somethingWentWrongError: 'Une erreur s’est produite pendant le processus de soumission. Veuillez réessayer plus tard.'
    };
    return resources[label];
};
